import React from "react";
import {Route, Redirect} from "react-router-dom";

const ProtectedRoute = ({ component: Component, isLoggedIn, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      isLoggedIn ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: "/login",
            state: {prevLocation: props.location.pathname}
          }}
        />
      )
    }
  />
);

export default ProtectedRoute;
